import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the details bets report view.
 * @extends JetView
 */
export default class detailsBetsReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Get the current screen size

        // Main information section with a textarea for logs
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea', // Textarea for displaying logs
                    name: 'Log', // Name of the textarea
                    label: _('Log'), // Localized label for the textarea
                    labelPosition: 'top', // Position of the label
                    disabled: true, // Disable the textarea for editing
                },
            ],
        };

        // Left main section layout
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Include main_info in the left section
        };

        // Upper section layout with multiview and scroll
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 20 }], // Columns layout
        };

        // Narrow upper section layout for small screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info], // Include main_info in the narrow section
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form', // Form view
            rows: [screen !== 'small' ? upper_section : upper_section_narrow], // Conditional layout based on screen size
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for fname
            },
        };
    }

    /**
     * Initializes the view and fetches log data for the current user.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        const cur_user = this.getParam('user', true); // Get the current user parameter

        // AJAX request to fetch log data
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(
                devConfig.geturlApi() + 'Machine/GetLogMachine', // API endpoint
                '{"Id":"' + cur_user + '"}', // Request payload with user ID
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error handling
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse the response
                        form.setValues(resp.Data); // Set the form values with the response data
                    },
                },
            );
    }
}

// FILE DOCUMENTED
